import { requestApi } from '../util/network'

// 添加反馈意见
export const addFeedback =
    (feedback) =>
      requestApi(
        '/Memberfeedback/feedback_add',
        'POST',
        {
          feedback: feedback
        },
        'member'
      )
// 反馈列表
export const getFeedbackList =
    (params) =>
      requestApi(
        '/Memberfeedback/feedback_list',
        'POST',
        {
          page: params.page,
          per_page: params.per_page
        },
        'member'
      )
